import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface CheckBulletItemProps {
  children: ReactNode;
  className?: string;
}

// A list item with the Website 2.0 green tick bullet (benefit lists in the
// tier studio, membership builder...). Render inside any <ul>.
const CheckBulletItem = ({ children, className }: CheckBulletItemProps) => (
  <li
    className={cn(
      "relative pl-6 text-[15px] before:absolute before:left-0 before:font-extrabold before:text-tone-mint-ink before:content-['✓']",
      className,
    )}
  >
    {children}
  </li>
);

export default CheckBulletItem;
